import cssMobile from '../../../css/editorMobile.module.css'
import {fontFamilies, FontFamilyType} from '../../../models/editor/fontFamily'
import {useAppDispatch, useAppSelector} from '../../../stores/configureStore'
import {handleUpdatedAttributes} from '../../../utils/helpers/attributeHelper'
import ControlsBase from './ControlsBase'

interface ControlsProps {
  open: boolean
  onBackClick?: () => void
}

export default function FontControls({open, onBackClick}: ControlsProps) {
  const dispatch = useAppDispatch()
  const selectedImage = useAppSelector(store =>
    store.editor.images.find(
      image => image.id === store.editor.selectedImageId,
    ),
  )

  return (
    <ControlsBase open={open} onBackClick={onBackClick}>
      <select
        className={cssMobile.input}
        value={
          selectedImage?.type === 'caption'
            ? selectedImage.fontFamily
            : 'Aclonica'
        }
        onChange={e => {
          if (selectedImage) {
            handleUpdatedAttributes(dispatch, selectedImage, {
              fontFamily: e.target.value as FontFamilyType,
            })
          }
        }}>
        {fontFamilies.map(fontFamily => (
          <option
            key={`fontFamilyMobile_${fontFamily}`}
            value={fontFamily}
            style={{fontFamily: fontFamily}}>
            {fontFamily}
          </option>
        ))}
      </select>
    </ControlsBase>
  )
}
